/**
 * 右键菜单动画
 */
import fvAnimation from "./fvAnimation"
export default class fvContextMenu extends fvAnimation {
    constructor(shape){
        super(shape,"fvContextMenu");
        this.item = this.shape.animation.fvContextMenu.item;
        this.align = this.shape.animation.fvContextMenu.align;
    }

    run(event,value){
        if(value == false) return;
        if(!this.shape.mouseState){
            return;
        }
        if(this.shape.mouseState && event.button == 2 ) {
            this.action(event);
        }else if(event.touches){
            this.action(event);
        }
    }
    action(event){
        var style = {
            position:'absolute',
            zIndex:2000,
            left:event.clientX+'px',
            top:event.clientY-18+'px',
        }
        if(this.getEventType(event.type) == "down"){
            if(this.shape.animation.fvContextMenu){
                var menuList = [];
                var windowName = [];
                if(this.shape.system){
                    this.shape.system.$.jsonSysRootConfig.contextMenu.forEach(function(element) {
                        if(element.title == this.item){
                            element.item.forEach((e)=>{
                                menuList.push({menuItem:e.itemName});
                                windowName.push({windowName:e.windowName,action:e.action,condition:e.condition})
                            })
                        }
                    }, this);
                    this.shape.system.contextMenu.$.isContextmenu = true;
                    this.shape.system.contextMenu.$.show(event,1,style,menuList,this.align,windowName);
                }else{
                    this.shape.fvSystemApi.system.$.jsonSysRootConfig.contextMenu.forEach(function(element) {
                        if(element.title == this.item){
                            element.item.forEach((e)=>{
                                menuList.push({menuItem:e.itemName});
                                windowName.push({windowName:e.windowName,action:e.action,condition:e.condition})
                            })
                        }
                    }, this);
                    this.shape.fvSystemApi.system.contextMenu.$.isContextmenu = true;
                    this.shape.fvSystemApi.system.contextMenu.$.show(event,1,style,menuList,this.align,windowName);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvContextMenu.js